import Http from 'axios'
import { API_URL, VERSION } from '../../config/config'

function initialState() {
    return {
        id: null,
        model: null,
        all: [],
        query: '',
        serverPagination: {
            page: 1,
            rowsNumber: 0,
            descending: false,
            itemsPerPage: 25,
        },
        totalNumber: 0,
        filters: {},
        loading: false,
        modelData: {},
        exportRows: 10,
        exportName: '',
        links: {
            next: null,
            prev: null
        }
    }
}

const getters = {
    all: state => state.all,
    loading: state => state.loading,
    serverPagination: state => state.serverPagination,
    filters: state => state.filters,
    query: state => state.query,
    model: state => state.model,
    totalNumber: state => state.totalNumber,
    exportRows: state => state.exportRows,
    exportName: state => state.exportName,
};

const actions = {
    async getAll({ commit, state }) {
        commit('setLoading', true);
        let pagination = state.serverPagination;
        let serverParams = {
            paginate: true,
            page: pagination.page,
            rowsPerPage: pagination.itemsPerPage,
            query: state.query,
            sortBy: pagination.sortBy ? pagination.sortBy[0] : null,
            descending: pagination.sortDesc ? pagination.sortDesc[0] : null
        };
        serverParams = {...serverParams, ...state.filters };
        Http.get(API_URL + VERSION + '/' + state.model, {
            params: serverParams
        }).then(response => {
            commit('setAll', response.data.data);
            commit('setTotalNumber', response.data.meta.total);
            commit('setLinks', response.data.links)
        }).finally(() => {
            commit('setLoading', false)
        })
    },
    exportFilteredData({ commit, state }) {
        commit('setLoading', true);
        let pagination = state.serverPagination;
        let serverParams = {
            paginate: true,
            page: pagination.page,
            exportRows: state.exportRows,
            exportName: state.exportName,
            query: state.query,
            sortBy: pagination.sortBy ? pagination.sortBy[0] : null,
            descending: pagination.sortDesc ? pagination.sortDesc[0] : null
        };
        serverParams = {...serverParams, ...state.filters };
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/' + state.model + '/export', serverParams)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
                .finally(() => {
                    commit('setLoading', false)
                })
        });
    },

    create({ commit, state }) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/' + state.model + '/save', state.modelData)
                .then(response => {
                    commit('setLoading', false)
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },

    show({ commit, state }) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/' + state.model + '/' + state.id)
                .then(response => {
                    commit('setLoading', false);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })

        })
    },

    store({ commit, state }) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/' + state.model, state.modelData)
                .then(response => {
                    commit('setLoading', false);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },
    update({ commit, state }) {
        commit('setLoading', true);
        let id = state.id;
        if (state.modelData.id) {
            id = state.modelData.id;
        }
        return new Promise((resolve, reject) => {
            Http.put(API_URL + VERSION + '/' + state.model + '/' + id, state.modelData)
                .then(response => {
                    commit('setLoading', false)
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    delete({ commit, state }, item) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            Http.delete(API_URL + VERSION + '/' + state.model + '/' + item)
                .then(response => {
                    commit('setLoading', false)
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    resetState({ commit }) {
        commit('resetState')
    }
}

const mutations = {
    setAll(state, items) {
        items = items.map((item, index) => {
            item.s_no = (state.serverPagination.page - 1) * state.serverPagination.itemsPerPage + (index + 1);
            return item;
        });
        state.all = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setId(state, id) {
        state.id = id
    },
    setModel(state, model) {
        state.model = model
    },
    setServerPagination(state, item) {
        state.serverPagination = item
    },
    setTotalNumber(state, item) {
        state.totalNumber = item
    },
    setQuery(state, query) {
        state.query = query
    },
    setModelData(state, data) {
        state.modelData = data
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setFilters(state, item) {
        state.filters = item
    },
    setLinks(state, item) {
        state.links = item;
    },
    setExportRows(state, item) {
        state.exportRows = item
    },
    setExportName(state, item) {
        state.exportName = item
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}